import { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';

import AddressDisplay from 'common/components/address/AddressDisplay';
import { Modal } from 'common/components/layout';
import { editClubMembership } from 'redux/clubMemberships/actions';
import { getActiveClubMemberships } from 'redux/clubMemberships/reducers';

import { activeClubMembershipsWithoutThisAddress } from '../helpers';

class ClubMembershipAddressVerify extends Component {
  constructor(props) {
    super(props);
    const potentialMemberships = activeClubMembershipsWithoutThisAddress(
      props.addressId,
      props.activeClubMemberships
    );
    if (potentialMemberships.length === 1) {
      this.state = {
        [potentialMemberships[0].id]: true
      };
    } else {
      const object = {};
      potentialMemberships.forEach((membership) => {
        object[membership.id] = false;
      });
      this.state = object;
    }
  }

  handleSubmit = () => {
    const { props, state } = this;
    const clubMembershipArrayIds = Object.keys(state);
    const changedIds = clubMembershipArrayIds.filter(
      (cmId) => state[cmId] === true
    );
    changedIds.forEach((id) => {
      const data = {
        orderDeliveryMethod: 'Ship',
        shipToCustomerAddressId: props.addressId
      };
      props.editClubMembership(id, data);
    });
    props.onCloseModal();
  };

  handleCancel = (e) => {
    const { props } = this;
    e.preventDefault();
    props.onCloseModal();
  };

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.checked });
  };

  render() {
    const { addressId, customerAddresses, activeClubMemberships } = this.props;
    const { onCloseModal } = this.props;
    const { state } = this;
    const address = customerAddresses.data[addressId];
    const potentialMemberships = activeClubMembershipsWithoutThisAddress(
      addressId,
      activeClubMemberships
    );
    const isOneOneArray = Object.keys(this.state);

    const isOneOne = isOneOneArray.find(
      (clubMembershipId) => state[clubMembershipId] === true
    );
    return (
      <Modal title="Add Address to Club Membership" onCloseModal={onCloseModal}>
        {potentialMemberships.length === 1 && (
          <p>
            Would you like to make this address your shipping address for{' '}
            {potentialMemberships[0].club.title}
          </p>
        )}
        {potentialMemberships.length > 1 && (
          <>
            <p>
              Would you like to make this address your shipping address for
              following clubs:
            </p>
            <p>
              {potentialMemberships.map((membership) => (
                <Fragment key={membership.id}>
                  <input
                    type="checkbox"
                    name={membership.id}
                    checked={state[membership.id]}
                    onChange={this.handleChange}
                    id={membership.id}
                  />{' '}
                  <label htmlFor={membership.id}>{membership.club.title}</label>
                  <br />
                </Fragment>
              ))}
            </p>
          </>
        )}
        <AddressDisplay address={address} boldName />
        <br />
        <div className="c7-form__button-row">
          <a
            onClick={this.handleCancel}
            onKeyPress={this.handleKeyPress}
            role="link"
            tabIndex={0}
            className="c7-button-alt"
          >
            No
          </a>
          {isOneOne && (
            <button
              type="submit"
              onClick={this.handleSubmit}
              className="c7-button"
            >
              Yes
            </button>
          )}
        </div>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => ({
  activeClubMemberships: getActiveClubMemberships(state.clubMembership),
  settings: state.setting,
  customerAddresses: state.customerAddress
});

ClubMembershipAddressVerify = reduxForm({
  form: 'ClubMembershipAddressVerify',
  enableReinitialize: true,
  onSubmitFail: (err, dispatch) => {
    dispatch({ type: 'ADD_FORM_ERROR', payload: err });
  },
  onSubmitSuccess: (result, dispatch) => {
    dispatch({ type: 'REMOVE_FORM_ERROR' });
  }
})(ClubMembershipAddressVerify);

export default connect(mapStateToProps, {
  editClubMembership
})(ClubMembershipAddressVerify);
